import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import { Dialog, IconButton, Slide, Tab, Tabs, TextField } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Tooltip from "@mui/material/Tooltip";
import "./ProfileInfo.css";
import ChatContactInformation from "./ChatContactInformation";
import ModalHistory from "../ModalHistory";
import EditTicket from "../../Components/EditTicket";
import Loader from "../../Components/Loader";
import TicketLog from "../../Contact/TicketLog";
import Interaction from "../../Contact/Interaction";
import { getCustomerDetail } from "../../Store/Actions/ContactAction";

export default function ProfileInfo({
  contactID,
  contactName,
  detailchat,
  open,
  onClose,
  selectContact,
}) {
  const [openModal, setOpenModal] = useState(false);
  const [contactInfo, setContactInfo] = useState([]);
  const [historyChatListID, setHistoryChatListID] = useState(0);
  const [isContactNotFound, setIsContactNotFound] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [ticketAction, setTicketAction] = useState("");
  const [tab, setTab] = useState(0);
  const { isInCall } = useSelector((state) => state.call);
  const { updateChatContactInfo } = useSelector((state) => state.chat);

  useEffect(() => {
    if (open && contactID) {
      setIsContactNotFound(false);
      setIsLoading(true);

      getCustomerDetail(contactID)
        .then((response) => {
          if (response.status) {
            console.log("contact info", response.data);
            setContactInfo(response.data);
            setIsLoading(false);
          } else {
            console.log("error", response.error);
            setIsLoading(false);
            setIsContactNotFound(true);
          }
        })
        .catch((err) => {
          console.log("err", err);
          setIsLoading(false);
          setIsContactNotFound(true);
        });
    }
  }, [open, contactID, updateChatContactInfo]);

  const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && children}
      </div>
    );
  };

  function renderContactDetail(data) {
    if (data && Object.entries(data).length) {
      const fields = [];
      const entries = Object.entries(data);

      entries.forEach((element, index) => {
        fields.push(
          <TextField
            InputProps={{
              readOnly: true,
            }}
            key={index}
            label={entries[index][0]}
            value={entries[index][1] ?? ""}
          />
        );
      });

      return <div className="profile-contact-detail">{fields}</div>;
    } else
      return (
        <div className="profile-contact-detail">
          <p className="no-contact-detail">Contact detail data unavailable</p>
        </div>
      );
  }

  return (
    <Slide appear direction="left" in={open} unmountOnExit>
      <div className={`ProfileInfo ${isInCall && "inCall"}`}>
        {!contactID || isContactNotFound ? (
          <>
            <div className="ProfileInfo_header">
              <Tooltip arrow title="Close" placement="left">
                <IconButton onClick={onClose}>
                  <Icon icon="tabler:x" height="26" color="#727272" />
                </IconButton>
              </Tooltip>
            </div>

            <div className="no-contact-selected">
              <Icon color="#727272" height="72" icon="bi:person-x-fill" />
              <p>No contact selected</p>

              <button className="select-contact-button" onClick={selectContact}>
                Select contact
              </button>
            </div>
          </>
        ) : isLoading ? (
          <Loader />
        ) : (
          <>
            <div className="ProfileInfo_header">
              <Tooltip arrow title="Close" placement="left">
                <IconButton onClick={onClose}>
                  <Icon icon="tabler:x" height="26" color="#727272" />
                </IconButton>
              </Tooltip>

              <Tooltip arrow title="Reassign Contact" placement="left">
                <IconButton onClick={selectContact}>
                  <Icon
                    icon="ant-design:user-switch-outlined"
                    height="26"
                    color="#727272"
                  />
                </IconButton>
              </Tooltip>

              {openModal && historyChatListID > 0 ? (
                <ModalHistory
                  onClose={() => setOpenModal(false)}
                  ChatListID={historyChatListID}
                  detailchat={detailchat}
                ></ModalHistory>
              ) : (
                ""
              )}
            </div>

            <div className="ProfileInfo_Body_Data">
              <div className="ProfileInfo_Body">
                <AccountCircleIcon className="ProfileInfo_Avatar" />

                <div className="Grid">
                  <div className="ProfileInfo_info">
                    <span className="ProfileInfo_username">
                      {contactInfo[0][0].ContactName}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <Tabs
              value={tab}
              variant="fullWidth"
              onChange={(event, value) => setTab(value)}
            >
              <Tooltip arrow placement="top" title="Contact information">
                <Tab
                  icon={
                    <Icon
                      height="32"
                      icon="material-symbols:contact-page-rounded"
                    />
                  }
                />
              </Tooltip>

              <Tooltip arrow placement="top" title="Ticket log">
                <Tab icon={<Icon height="32" icon="iconamoon:ticket" />} />
              </Tooltip>

              <Tooltip arrow placement="top" title="Interaction history">
                <Tab
                  icon={<Icon height="32" icon="material-symbols:history" />}
                />
              </Tooltip>

              <Tooltip arrow placement="top" title="Contact details">
                <Tab icon={<Icon height="32" icon="bxs:user-detail" />} />
              </Tooltip>
            </Tabs>

            <TabPanel
              value={tab}
              index={0}
              className={`tab-panel ${
                tab === 0 ? "contact-info-tab-panel" : ""
              }`}
            >
              <ChatContactInformation contactInfo={contactInfo} />
            </TabPanel>

            <TabPanel value={tab} index={1} className="tab-panel">
              <TicketLog
                contactDetailData={contactInfo[1][0]}
                data={contactInfo[3]}
                setSelectedTicket={setSelectedTicket}
                setTicketAction={setTicketAction}
              />
            </TabPanel>

            <TabPanel value={tab} index={2} className="tab-panel">
              <Interaction data={contactInfo[2]} />
            </TabPanel>

            <TabPanel value={tab} index={3} className="tab-panel">
              {renderContactDetail(contactInfo[5][0])}
            </TabPanel>

            <Dialog
              open={ticketAction === "edit"}
              className="dialog"
              fullWidth
              maxWidth="xl"
              scroll="paper"
              onClose={() => setTicketAction("")}
            >
              <EditTicket
                caseID={selectedTicket}
                setTicketAction={setTicketAction}
              />
            </Dialog>
          </>
        )}
      </div>
    </Slide>
  );
}
